export const apiPath = '/v2/digital_form_templates';
const actionType = 'DIGITAL_FORM_TEMPLATE';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
